/* CraftKitties theme — small JS for dropdown, cart drawer, fav heart */
(function () {
  'use strict';

  // ===== Categories dropdown =====
  function initCatsDropdown() {
    document.querySelectorAll('[data-ck-cats]').forEach(function (wrap) {
      var btn = wrap.querySelector('[data-ck-cats-toggle]');
      var dropdown = wrap.querySelector('.ck-cats-dropdown');
      if (!btn || !dropdown) return;

      var open = false;
      function setOpen(v) {
        open = v;
        btn.setAttribute('aria-expanded', v ? 'true' : 'false');
        dropdown.setAttribute('data-open', v ? 'true' : 'false');
      }

      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        setOpen(!open);
      });

      document.addEventListener('mousedown', function (e) {
        if (open && !wrap.contains(e.target)) setOpen(false);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && open) {
          setOpen(false);
          btn.focus();
        }
      });
    });
  }

  // ===== Cart drawer (slide-out right) =====
  function initCartDrawer() {
    var drawer = document.querySelector('[data-ck-cart-drawer]');
    if (!drawer) return;

    var backdrop = drawer.querySelector('[data-ck-cart-backdrop]');
    var closeBtns = drawer.querySelectorAll('[data-ck-cart-close]');
    var openTriggers = document.querySelectorAll('[data-ck-cart-open]');

    function open() {
      drawer.setAttribute('data-open', 'true');
      document.body.style.overflow = 'hidden';
      refreshCart();
    }
    function close() {
      drawer.setAttribute('data-open', 'false');
      document.body.style.overflow = '';
    }

    openTriggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        // Allow Cmd/Ctrl-click to navigate to /cart in new tab
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
        e.preventDefault();
        open();
      });
    });
    if (backdrop) backdrop.addEventListener('click', close);
    closeBtns.forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') close();
    });

    // Refresh cart contents from /cart.js
    function refreshCart() {
      var body = drawer.querySelector('[data-ck-cart-body]');
      var subtotalEl = drawer.querySelector('[data-ck-cart-subtotal]');
      var countEl = drawer.querySelector('[data-ck-cart-drawer-count]');
      var progressBar = drawer.querySelector('[data-ck-cart-progress]');
      var progressLabel = drawer.querySelector('[data-ck-cart-progress-label]');
      var freeShippingThresholdCents = parseInt(drawer.getAttribute('data-free-shipping-threshold-cents') || '0', 10);
      var moneyFormat = drawer.getAttribute('data-money-format') || '${{amount}}';

      if (!body) return;
      body.setAttribute('aria-busy', 'true');
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // Update count badges everywhere
          var headerCount = document.querySelector('[data-ck-cart-count]');
          if (headerCount) {
            headerCount.textContent = cart.item_count;
            if (cart.item_count > 0) headerCount.removeAttribute('hidden');
            else headerCount.setAttribute('hidden', '');
          }
          if (countEl) countEl.textContent = cart.item_count;

          // Subtotal
          if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price, moneyFormat);

          // Free shipping bar
          if (progressBar && freeShippingThresholdCents > 0) {
            var pct = Math.min(100, Math.round((cart.total_price / freeShippingThresholdCents) * 100));
            progressBar.style.width = pct + '%';
            if (progressLabel) {
              if (cart.total_price >= freeShippingThresholdCents) {
                progressLabel.textContent = '🎉 You unlocked free shipping!';
              } else {
                var remaining = freeShippingThresholdCents - cart.total_price;
                progressLabel.textContent = 'Add ' + formatMoney(remaining, moneyFormat) + ' more for free shipping';
              }
            }
          }

          // Items
          if (cart.items.length === 0) {
            body.innerHTML = '<div class="ck-cart-empty">'
              + '<p>Your cart is empty</p>'
              + '<a href="/collections/all" class="ck-btn ck-btn-orange">Browse all wooden goods</a>'
              + '</div>';
          } else {
            body.innerHTML = cart.items.map(function (item) {
              var imgUrl = item.image
                ? item.image.replace('.jpg', '_180x180.jpg').replace('.png', '_180x180.png').replace('.webp', '_180x180.webp')
                : '';
              return '<div class="ck-cart-item" data-key="' + item.key + '">'
                + '<a href="' + item.url + '" class="ck-cart-item-img">'
                + (imgUrl ? '<img src="' + imgUrl + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' : '<div class="ck-cart-item-img-placeholder"></div>')
                + '</a>'
                + '<div class="ck-cart-item-meta">'
                + '<a href="' + item.url + '" class="ck-cart-item-title">' + escapeHtml(item.product_title) + '</a>'
                + (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="ck-cart-item-variant">' + escapeHtml(item.variant_title) + '</div>' : '')
                + '<div class="ck-cart-item-row">'
                + '<div class="ck-cart-qty">'
                + '<button type="button" data-ck-qty-dec aria-label="Decrease quantity">−</button>'
                + '<span data-ck-qty>' + item.quantity + '</span>'
                + '<button type="button" data-ck-qty-inc aria-label="Increase quantity">+</button>'
                + '</div>'
                + '<button type="button" class="ck-cart-remove" data-ck-remove>Remove</button>'
                + '</div>'
                + '</div>'
                + '<div class="ck-cart-item-price">' + formatMoney(item.final_line_price, moneyFormat) + '</div>'
                + '</div>';
            }).join('');

            // Wire qty + remove
            body.querySelectorAll('.ck-cart-item').forEach(function (row) {
              var key = row.getAttribute('data-key');
              var qtyEl = row.querySelector('[data-ck-qty]');
              row.querySelector('[data-ck-qty-inc]').addEventListener('click', function () {
                changeQty(key, parseInt(qtyEl.textContent, 10) + 1);
              });
              row.querySelector('[data-ck-qty-dec]').addEventListener('click', function () {
                changeQty(key, Math.max(0, parseInt(qtyEl.textContent, 10) - 1));
              });
              row.querySelector('[data-ck-remove]').addEventListener('click', function () {
                changeQty(key, 0);
              });
            });
          }
          body.setAttribute('aria-busy', 'false');
        })
        .catch(function () {
          body.setAttribute('aria-busy', 'false');
        });
    }

    function changeQty(key, qty) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () { refreshCart(); });
    }

    // Hook into add-to-cart forms
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (form.getAttribute('action') === '/cart/add' || form.getAttribute('action') === (window.routes && window.routes.cart_add_url)) {
        if (form.hasAttribute('data-ck-no-drawer')) return;
        e.preventDefault();
        var fd = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          body: fd,
          headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json(); })
          .then(function () {
            var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
            window.location.href = cartUrl;
          })
          .catch(function () { form.removeAttribute('data-ck-no-drawer'); form.submit(); });
      }
    });

    // Refresh on initial load (so badge syncs across pages)
    refreshCart();

    // Expose to window for external triggers
    window.CKCartDrawer = { open: open, close: close, refresh: refreshCart };
  }

  function formatMoney(cents, format) {
    var amount = (cents / 100).toFixed(2);
    return format.replace('{{amount}}', amount).replace('{{ amount }}', amount);
  }
  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // ===== Favorites (localStorage based) =====
  var FAV_KEY = 'ck-favorites';

  function getFavorites() {
    try {
      var raw = localStorage.getItem(FAV_KEY);
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  }
  function setFavorites(map) {
    try { localStorage.setItem(FAV_KEY, JSON.stringify(map)); } catch (e) {}
  }
  function favCount(map) {
    return Object.keys(map || {}).length;
  }
  function syncFavCountBadge() {
    var badges = document.querySelectorAll('[data-ck-fav-count]');
    var n = favCount(getFavorites());
    badges.forEach(function (b) {
      b.textContent = n;
      if (n > 0) b.removeAttribute('hidden');
      else b.setAttribute('hidden', '');
    });
  }
  function syncFavButtons() {
    var favs = getFavorites();
    document.querySelectorAll('[data-ck-fav-toggle-product]').forEach(function (btn) {
      var handle = btn.getAttribute('data-ck-fav-toggle-product');
      if (favs[handle]) {
        btn.classList.add('active');
        btn.setAttribute('aria-label', 'Remove from favorites');
      } else {
        btn.classList.remove('active');
        btn.setAttribute('aria-label', 'Save to favorites');
      }
    });
  }

  function initFavorites() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ck-fav-toggle-product]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      var handle = btn.getAttribute('data-ck-fav-toggle-product');
      var title = btn.getAttribute('data-ck-fav-title');
      var url = btn.getAttribute('data-ck-fav-url');
      var favs = getFavorites();
      if (favs[handle]) {
        delete favs[handle];
      } else {
        favs[handle] = { title: title, url: url, addedAt: Date.now() };
      }
      setFavorites(favs);
      syncFavButtons();
      syncFavCountBadge();
      // visual pulse
      btn.style.transform = 'scale(1.18)';
      setTimeout(function () { btn.style.transform = ''; }, 180);
    });

    syncFavButtons();
    syncFavCountBadge();
  }

  // ===== Favorites page renderer =====
  function initFavoritesPage() {
    var root = document.querySelector('[data-ck-favorites-root]');
    if (!root) return;
    var loadingEl = root.querySelector('[data-ck-favorites-loading]');
    var emptyEl = root.querySelector('[data-ck-favorites-empty]');
    var gridEl = root.querySelector('[data-ck-favorites-grid]');
    var countEl = root.querySelector('[data-ck-favorites-count]');
    var favs = getFavorites();
    var handles = Object.keys(favs).sort(function (a, b) {
      return (favs[b].addedAt || 0) - (favs[a].addedAt || 0);
    });
    if (countEl) countEl.textContent = '(' + handles.length + ')';

    if (handles.length === 0) {
      if (loadingEl) loadingEl.setAttribute('hidden', '');
      if (emptyEl) emptyEl.removeAttribute('hidden');
      return;
    }
    if (gridEl) gridEl.removeAttribute('hidden');
    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var html = products.filter(Boolean).map(function (p) {
        var img = p.featured_image ? p.featured_image.replace(/^\/\//, 'https://') : '';
        var pct = p.compare_at_price && p.compare_at_price > p.price
          ? Math.round((1 - p.price / p.compare_at_price) * 100) : 0;
        var priceNow = formatMoney(p.price, root.getAttribute('data-money-format') || '${{amount}}');
        var priceWas = p.compare_at_price && p.compare_at_price > p.price
          ? formatMoney(p.compare_at_price, root.getAttribute('data-money-format') || '${{amount}}') : '';
        return '<a href="' + (p.url || '/products/' + p.handle) + '" class="ck-card" data-ck-product-handle="' + p.handle + '">'
          + '<div class="ck-card-img">'
          + (img ? '<img src="' + img + '" alt="' + escapeHtml(p.title) + '" loading="lazy" style="width:100%;height:100%;object-fit:cover;display:block;">' : '')
          + (pct > 0 ? '<span class="ck-badge">-' + pct + '%</span>' : '')
          + '<button type="button" class="ck-fav active" data-ck-fav-toggle-product="' + p.handle + '" data-ck-fav-title="' + escapeHtml(p.title) + '" data-ck-fav-url="' + (p.url || '') + '" aria-label="Remove from favorites">'
          + '<svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>'
          + '</button>'
          + '</div>'
          + '<div class="ck-card-body">'
          + '<div class="ck-card-title">' + escapeHtml(p.title) + '</div>'
          + '<div class="ck-card-price"><span class="ck-price-now">' + priceNow + '</span>'
          + (priceWas ? '<span class="ck-price-was">' + priceWas + '</span>' : '')
          + (pct > 0 ? '<span class="ck-price-off">(' + pct + '% off)</span>' : '')
          + '</div>'
          + '</div>'
          + '</a>';
      }).join('');
      gridEl.innerHTML = html;
      if (loadingEl) loadingEl.setAttribute('hidden', '');
      syncFavButtons();
    });
  }

  // ===== Predictive search dropdown =====
  function initSearchSuggest() {
    document.querySelectorAll('[data-ck-search-wrap]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-ck-search-input]');
      var panel = wrap.querySelector('[data-ck-search-suggest]');
      var defaultBlock = wrap.querySelector('[data-ck-search-default]');
      var resultsBlock = wrap.querySelector('[data-ck-search-results]');
      if (!input || !panel || !resultsBlock) return;

      var openPanel = function () {
        panel.removeAttribute('hidden');
        input.setAttribute('aria-expanded', 'true');
      };
      var closePanel = function () {
        panel.setAttribute('hidden', '');
        input.setAttribute('aria-expanded', 'false');
      };

      input.addEventListener('focus', openPanel);

      var debounceTimer;
      input.addEventListener('input', function () {
        clearTimeout(debounceTimer);
        var q = input.value.trim();
        if (!q) {
          if (defaultBlock) defaultBlock.removeAttribute('hidden');
          resultsBlock.setAttribute('hidden', '');
          openPanel();
          return;
        }
        debounceTimer = setTimeout(function () { fetchSuggestions(q); }, 180);
      });

      function fetchSuggestions(q) {
        var url = '/search/suggest.json?q=' + encodeURIComponent(q)
          + '&resources[type]=product,collection,article,page'
          + '&resources[limit]=5&resources[options][unavailable_products]=last';
        fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var resources = (data && data.resources && data.resources.results) || {};
            var products = resources.products || [];
            var collections = resources.collections || [];
            var articles = resources.articles || [];
            var pages = resources.pages || [];

            if (products.length === 0 && collections.length === 0 && articles.length === 0 && pages.length === 0) {
              resultsBlock.innerHTML = '<div class="ck-search-suggest-empty"><div class="ck-search-suggest-empty-text">No quick matches for &quot;' + escapeHtml(q) + '&quot;.</div><a href="/search?q=' + encodeURIComponent(q) + '" class="ck-btn ck-btn-orange ck-search-suggest-cta">See full search results →</a></div>';
            } else {
              var html = '';
              if (products.length > 0) {
                html += '<div class="ck-search-suggest-section"><div class="ck-search-suggest-h">Products</div><div class="ck-search-suggest-products">';
                html += products.map(function (p) {
                  var img = p.featured_image && p.featured_image.url ? p.featured_image.url : (p.image || '');
                  return '<a href="' + p.url + '" class="ck-search-suggest-product">'
                    + (img ? '<img src="' + img + '&width=120" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '<div class="ck-search-suggest-product-placeholder"></div>')
                    + '<div><div class="ck-search-suggest-product-title">' + escapeHtml(p.title) + '</div>'
                    + (p.price ? '<div class="ck-search-suggest-product-price">' + p.price + '</div>' : '')
                    + '</div></a>';
                }).join('');
                html += '</div></div>';
              }
              if (collections.length > 0) {
                html += '<div class="ck-search-suggest-section"><div class="ck-search-suggest-h">Collections</div><div class="ck-search-suggest-list">';
                html += collections.map(function (c) {
                  return '<a href="' + c.url + '" class="ck-search-suggest-list-item"><span class="ck-search-suggest-list-icon">📁</span>' + escapeHtml(c.title) + '</a>';
                }).join('');
                html += '</div></div>';
              }
              if (pages.length > 0) {
                html += '<div class="ck-search-suggest-section"><div class="ck-search-suggest-h">Pages</div><div class="ck-search-suggest-list">';
                html += pages.map(function (p) {
                  return '<a href="' + p.url + '" class="ck-search-suggest-list-item"><span class="ck-search-suggest-list-icon">📄</span>' + escapeHtml(p.title) + '</a>';
                }).join('');
                html += '</div></div>';
              }
              if (articles.length > 0) {
                html += '<div class="ck-search-suggest-section"><div class="ck-search-suggest-h">From our journal</div><div class="ck-search-suggest-list">';
                html += articles.map(function (a) {
                  return '<a href="' + a.url + '" class="ck-search-suggest-list-item"><span class="ck-search-suggest-list-icon">✍︎</span>' + escapeHtml(a.title) + '</a>';
                }).join('');
                html += '</div></div>';
              }
              html += '<a href="/search?q=' + encodeURIComponent(q) + '" class="ck-search-suggest-see-all">See all results for &quot;' + escapeHtml(q) + '&quot; →</a>';
              resultsBlock.innerHTML = html;
            }
            if (defaultBlock) defaultBlock.setAttribute('hidden', '');
            resultsBlock.removeAttribute('hidden');
            openPanel();
          })
          .catch(function () {});
      }

      // Outside click closes
      document.addEventListener('mousedown', function (e) {
        if (!wrap.contains(e.target)) closePanel();
      });
      // Escape closes
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !panel.hasAttribute('hidden')) {
          closePanel();
          input.blur();
        }
      });
    });
  }

  function init() {
    initCatsDropdown();
    initCartDrawer();
    initFavorites();
    initFavoritesPage();
    initSearchSuggest();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
